<template>
  <div>
    <!-- <div v-if="$vuetify.breakpoint.xs">
        <list-iklan v-if="iklan._source.promo == undefined" :item="iklan"/>
        <list-promo v-else :item="iklan"/>
    </div> -->

    <v-card
      @click="
        go(
          iklan._source.id,
          iklan._source.judul,
          iklan._source.unit_motor_bekas
        )
      "
      v-if="$vuetify.breakpoint.xs"
      elevation="1"
      :style="
        iklan._source.highlight
          ? 'border:2px solid #20929D;margin:0 auto'
          : 'margin:0 auto'
      "
      outlined
      width="100%"
    >
      <v-card-title
        v-if="iklan._source.highlight"
        style="position: absolute; z-index: 1; bottom: -16px; left: -16px"
      >
        <v-img src="../assets/border_highlight.webp" width="40px"></v-img>
      </v-card-title>
      <v-card-title style="position: absolute; z-index: 1; right: -26px">
        <v-img
          src="../assets/siappakai.png"
          width="70px"
          v-if="iklan._source.id_mst_iklan_jenis == 1"
        ></v-img>
      </v-card-title>
      <v-card-title style="position: absolute; z-index: 1; right: -24.5px">
        <v-img
          :src="
            start == true && end == false
              ? '../assets/live.png'
              : '../assets/belum_live.png'
          "
          :width="start == true && end == false ? '70px' : '60px'"
          v-if="iklan._source.id_mst_iklan_jenis == 2"
        >
        </v-img>
      </v-card-title>
      <v-card-title
        v-if="iklan._source.id_mst_iklan_jenis == 2"
        style="position: absolute; z-index: 1; right: -12px; top: -5px"
      >
        <div
          small
          color="#27AE60"
          class="white--text"
          dark
          v-if="start == true && end == false"
        >
          <countdown
            :time="countdown2 < 0 ? 0 : countdown2"
            v-slot="{ days, hours, minutes, seconds }"
            style="font-size: 10px"
          >
            <div
              class="d-flex justify-space-between align-center pr-1"
              v-if="days > 0"
            >
              <img style="width: 15px" src="../assets/live.gif" alt="" />
              {{ days }} hari
            </div>
            <div v-else>
              <div class="d-flex align-center pr-1" v-if="hours > 0">
                <img style="width: 15px" src="../assets/live.gif" alt="" />
                {{ hours }} j : {{ minutes }} m
              </div>
              <div v-else>
                <div class="d-flex align-center pr-1" v-if="minutes > 4">
                  <img style="width: 15px" src="../assets/live.gif" alt="" />
                  {{ hours }} j : {{ minutes }} m
                </div>
                <div v-else>
                  <div class="d-flex align-center pr-1" v-if="minutes > 0">
                    <img style="width: 15px" src="../assets/live.gif" alt="" />
                    {{ minutes }} m : {{ seconds }} d
                  </div>
                  <div class="d-flex align-center pr-1" v-else>
                    <img style="width: 15px" src="../assets/live.gif" alt="" />
                    {{ seconds }} detik
                  </div>
                </div>
              </div>
            </div>
          </countdown>
        </div>
        <div
          small
          color="#EB5757"
          class="white--text"
          dark
          v-if="start == false && end == false"
        >
          <countdown
            :time="countdown < 0 ? 0 : countdown"
            v-slot="{ days, hours, minutes, seconds }"
            style="font-size: 10px"
          >
            <div v-if="days > 0">{{ days }} hari</div>
            <div v-else>
              <div v-if="hours > 0">{{ hours }} j : {{ minutes }} m</div>
              <div v-else>
                <div v-if="minutes > 4">{{ hours }} j : {{ minutes }} m</div>
                <div v-else>
                  <div v-if="minutes > 0">
                    {{ minutes }} m : {{ seconds }} d
                  </div>
                  <div v-else>{{ seconds }} detik</div>
                </div>
              </div>
            </div>
          </countdown>
        </div>
        <div
          small
          color="#EB5757"
          class="white--text"
          dark
          style="font-size: 10px"
          v-if="start == true && end == true"
        >
          Selesai
        </div>
      </v-card-title>
      <v-list>
        <v-list-item>
          <v-img
            style="border-radius: 5px"
            max-width="80px"
            max-height="80px"
            min-height="80px"
            min-width="80px"
            :src="$url_img + iklan._source.photo"
            alt=""
          ></v-img>
          <v-list-item-content class="ml-3">
            <br />
            <v-list-item-subtitle class="teal--text">
              <h6 v-if="iklan._source.id_mst_iklan_jenis == 2">
                TB
                {{ iklan._source.mst_iklan_type }}
                {{ iklan._source.mst_type_tb }}
              </h6>
              <h6 v-else>
                {{ iklan._source.mst_iklan_jenis }}
              </h6>
            </v-list-item-subtitle>
            <!-- judul -->
            <h5 style="height: 30px" v-if="iklan._source.judul.length < 30">
              {{ iklan._source.judul }}
            </h5>
            <h5 style="height: 30px" v-else>
              {{ iklan._source.judul.substring(0, 30) + '..' }}
            </h5>

            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini == null &&
                  iklan._source.id_mst_iklan_jenis == 1
              "
            >
              Rp
              {{ Number(iklan._source.harga).toLocaleString('id-ID') }}
            </h4>
            <!-- TB -->
            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini == null &&
                  iklan._source.id_mst_iklan_jenis == 2
              "
            >
              <!-- harga awal -->
              Rp
              {{ Number(iklan._source.harga_awal).toLocaleString('id-ID') }}
            </h4>

            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini != null &&
                  iklan._source.id_mst_iklan_jenis == 2
              "
            >
              <!-- harga saat ini -->
              Rp
              {{ Number(iklan._source.harga_saat_ini).toLocaleString('id-ID')
              }}<sup><v-icon small color="red">mdi-arrow-up-bold</v-icon></sup>
            </h4>

            <!-- aksesoris -->
            <h4 class="red--text" v-if="iklan._source.id_mst_iklan_jenis == 5">
              Rp
              {{ Number(iklan._source.harga).toLocaleString('id-ID') }}
            </h4>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="pa-1"></v-divider>
        <v-card-actions v-if="!iklan._source.promo" class="pa-0" elevation="0">
          <v-spacer></v-spacer>
          <div class="d-flex justify-space-between px-3" style="width: 80%">
            <div style="width: 300px">
              <h5
                v-if="
                  iklan._source.lokasi == null ||
                    iklan._source.lokasi == undefined ||
                    iklan._source.lokasi == ''
                "
              >
                {{ iklan._source.app_user }}
              </h5>
              <h5 v-else>
                <v-icon class="mr-1">mdi-map-marker-outline</v-icon
                >{{ iklan._source.lokasi }}
              </h5>
            </div>
            <v-list-item-title class="d-flex" style="height: 20px">
              <v-spacer></v-spacer>
              <v-icon
                color="blue"
                class="mr-1"
                small
                v-if="iklan._source.id_mst_user_type == 2"
              >
                mdi-check-decagram
              </v-icon>
              <img
                v-if="iklan._source.garansi"
                src="../assets/ic_garansi.webp"
                width="20px"
                height="20px"
              />
            </v-list-item-title>
          </div>
        </v-card-actions>
      </v-list>
      <div
        style="margin-top: -10px"
        v-if="iklan._source.promo"
        class="d-flex justify-space-between align-center"
      >
        <img
          style="border-bottom-left-radius: 5px; width: 40px; height: 40px"
          src="../assets/border_kiri.png"
          alt=""
        />
        <div style="color: #20929d">
          <v-icon color="#20929D" small>mdi-check-decagram</v-icon>
          <b>Pilihan Simotor</b>
        </div>
        <img
          style="border-bottom-right-radius: 5px; width: 40px; height: 40px"
          src="../assets/border_kanan.png"
          alt=""
        />
      </div>
    </v-card>
    <v-card
      @click="
        go(
          iklan._source.id,
          iklan._source.judul,
          iklan._source.unit_motor_bekas
        )
      "
      v-else
      elevation="1"
      :style="
        iklan._source.highlight
          ? 'border:2px solid #20929D;margin:0 auto'
          : 'margin:0 auto'
      "
      outlined
      width="55%"
    >
      <v-card-title
        v-if="iklan._source.highlight"
        style="position: absolute; z-index: 1; bottom: -16px; left: -16px"
      >
        <v-img src="../assets/border_highlight.webp" width="40px"></v-img>
      </v-card-title>
      <v-card-title style="position: absolute; z-index: 1; right: -30px">
        <v-img
          src="../assets/siappakai.png"
          width="100px"
          v-if="iklan._source.id_mst_iklan_jenis == 1"
        ></v-img>
      </v-card-title>
      <v-card-title style="position: absolute; z-index: 1; right: -26.5px">
        <v-img
          :src="
            start == true && end == false
              ? '../assets/live.png'
              : '../assets/belum_live.png'
          "
          :width="start == true && end == false ? '100px' : '80px'"
          v-if="iklan._source.id_mst_iklan_jenis == 2"
        >
        </v-img>
      </v-card-title>
      <v-card-title
        v-if="iklan._source.id_mst_iklan_jenis == 2"
        style="position: absolute; z-index: 1; right: -8px; top: 0px"
      >
        <div
          small
          color="#27AE60"
          class="white--text"
          dark
          v-if="start == true && end == false"
        >
          <countdown
            :time="countdown2 < 0 ? 0 : countdown2"
            v-slot="{ days, hours, minutes, seconds }"
            style="font-size: 12px"
          >
            <div
              class="d-flex justify-space-between align-center pr-1"
              v-if="days > 0"
            >
              <img style="width: 25px" src="../assets/live.gif" alt="" />
              {{ days }} hari
            </div>
            <div v-else>
              <div class="d-flex align-center pr-1" v-if="hours > 0">
                <img style="width: 25px" src="../assets/live.gif" alt="" />
                {{ hours }} j : {{ minutes }} m
              </div>
              <div v-else>
                <div class="d-flex align-center pr-1" v-if="minutes > 4">
                  <img style="width: 25px" src="../assets/live.gif" alt="" />
                  {{ hours }} j : {{ minutes }} m
                </div>
                <div v-else>
                  <div class="d-flex align-center pr-1" v-if="minutes > 0">
                    <img style="width: 25px" src="../assets/live.gif" alt="" />
                    {{ minutes }} m : {{ seconds }} d
                  </div>
                  <div class="d-flex align-center pr-1" v-else>
                    <img style="width: 25px" src="../assets/live.gif" alt="" />
                    {{ seconds }} detik
                  </div>
                </div>
              </div>
            </div>
          </countdown>
        </div>
        <div
          small
          color="#EB5757"
          class="white--text"
          dark
          v-if="start == false && end == false"
        >
          <countdown
            :time="countdown < 0 ? 0 : countdown"
            v-slot="{ days, hours, minutes, seconds }"
            style="font-size: 12px"
          >
            <div v-if="days > 0">{{ days }} hari</div>
            <div v-else>
              <div v-if="hours > 0">{{ hours }} j : {{ minutes }} m</div>
              <div v-else>
                <div v-if="minutes > 4">{{ hours }} j : {{ minutes }} m</div>
                <div v-else>
                  <div v-if="minutes > 0">
                    {{ minutes }} m : {{ seconds }} d
                  </div>
                  <div v-else>{{ seconds }} detik</div>
                </div>
              </div>
            </div>
          </countdown>
        </div>
        <div
          small
          color="#EB5757"
          class="white--text"
          dark
          style="font-size: 12px"
          v-if="start == true && end == true"
        >
          Selesai
        </div>
      </v-card-title>
      <v-list>
        <v-list-item>
          <v-img
            style="border-radius: 5px"
            max-width="150px"
            max-height="150px"
            min-height="150px"
            min-width="150px"
            :src="$url_img + iklan._source.photo"
            alt=""
          ></v-img>
          <v-list-item-content class="ml-6">
            <v-list-item-subtitle class="teal--text">
              <h4 v-if="iklan._source.id_mst_iklan_jenis == 2">
                TB
                {{ iklan._source.mst_iklan_type }}
                {{ iklan._source.mst_type_tb }}
              </h4>
              <h4 v-else>
                {{ iklan._source.mst_iklan_jenis }}
              </h4>
            </v-list-item-subtitle>
            <!-- judul -->
            <h3 style="height: 30px" v-if="iklan._source.judul.length < 30">
              {{ iklan._source.judul }}
            </h3>
            <h3 style="height: 30px" v-else>
              {{ iklan._source.judul.substring(0, 30) + '..' }}
            </h3>

            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini == null &&
                  iklan._source.id_mst_iklan_jenis == 1
              "
            >
              Rp
              {{ Number(iklan._source.harga).toLocaleString('id-ID') }}
            </h4>
            <!-- TB -->
            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini == null &&
                  iklan._source.id_mst_iklan_jenis == 2
              "
            >
              <!-- harga awal -->
              Rp
              {{ Number(iklan._source.harga_awal).toLocaleString('id-ID') }}
            </h4>

            <h4
              class="red--text"
              v-if="
                iklan._source.harga_saat_ini != null &&
                  iklan._source.id_mst_iklan_jenis == 2
              "
            >
              <!-- harga saat ini -->
              Rp
              {{ Number(iklan._source.harga_saat_ini).toLocaleString('id-ID')
              }}<sup><v-icon small color="red">mdi-arrow-up-bold</v-icon></sup>
            </h4>

            <!-- aksesoris -->
            <h4 class="red--text" v-if="iklan._source.id_mst_iklan_jenis == 5">
              Rp
              {{ Number(iklan._source.harga).toLocaleString('id-ID') }}
            </h4>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="pa-1"></v-divider>
        <v-card-actions v-if="!iklan._source.promo" class="pa-0" elevation="0">
          <v-spacer></v-spacer>
          <div class="d-flex justify-space-between px-3" style="width: 80%">
            <div style="width: 300px">
              <h5
                v-if="
                  iklan._source.lokasi == null ||
                    iklan._source.lokasi == undefined ||
                    iklan._source.lokasi == ''
                "
              >
                {{ iklan._source.app_user }}
              </h5>
              <h5 v-else>
                <v-icon class="mr-1">mdi-map-marker-outline</v-icon
                >{{ iklan._source.lokasi }}
              </h5>
            </div>
            <v-list-item-title class="d-flex" style="height: 20px">
              <v-spacer></v-spacer>
              <v-icon
                color="blue"
                class="mr-1"
                small
                v-if="iklan._source.id_mst_user_type == 2"
              >
                mdi-check-decagram
              </v-icon>
              <img
                v-if="iklan._source.garansi"
                src="../assets/ic_garansi.webp"
                width="20px"
                height="20px"
              />
            </v-list-item-title>
          </div>
        </v-card-actions>
      </v-list>
      <div
        style="margin-top: -10px"
        v-if="iklan._source.promo"
        class="d-flex justify-space-between align-center"
      >
        <img
          style="border-bottom-left-radius: 5px; width: 40px; height: 40px"
          src="../assets/border_kiri.png"
          alt=""
        />
        <div style="color: #20929d">
          <v-icon color="#20929D" small>mdi-check-decagram</v-icon>
          <b>Pilihan Simotor</b>
        </div>
        <img
          style="border-bottom-right-radius: 5px; width: 40px; height: 40px"
          src="../assets/border_kanan.png"
          alt=""
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);
export default {
  name: 'banner-iklan',
  props: ['item', 'iklan'],

  filters: {
    dateTimeFormat: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('DD MMM, HH:mm');
    }
  },
  computed: {
    ...mapGetters({
      utc: 'timezone/utc',
      timezone: 'timezone/region'
    }),
    now: function() {
      return this.time;
    },
    start: function() {
      if (this.iklan._source.id_mst_iklan_jenis == 2) {
        return moment.utc(this.now).isAfter(this.iklan._source.tanggal_mulai);
      }
    },
    end: function() {
      if (this.iklan._source.id_mst_iklan_jenis == 2) {
        return moment.utc(this.now).isAfter(this.iklan._source.tanggal_selesai);
      }
    }
  },
  data: () => ({
    countdown: 0,
    countdown2: 0,
    dataIklan: []
  }),
  methods: {
    ...mapActions({
      setProductId: 'product/setProduct',
      setUnitID: 'product/setUnit'
    }),
    go(id, name, unit) {
      this.setProductId(id);

      // var routeData = this.$router.resolve(
      //   'https://simotor.devlmu.com/detail-iklan/' +
      //     name
      //       .toLowerCase()
      //       .replace(/ /g, '-')
      //       .replace(/[/]/g, '-') +
      //     '-' +
      //     id
      // );
      console.log(window.location);
      if (window.location.host != 'admin.simotor.id') {
        window.open(
          'https://simotor.devlmu.com/detail-iklan/' +
            name
              .toLowerCase()
              .replace(/ /g, '-')
              .replace(/[/]/g, '-') +
            '-' +
            id,
          '_blank'
        );
      } else {
        window.open(
          'https://simotor.id/detail-iklan/' +
            name
              .toLowerCase()
              .replace(/ /g, '-')
              .replace(/[/]/g, '-') +
            '-' +
            id,
          '_blank'
        );
      }

      if (unit != null) {
        this.setUnitID(unit);
      }
    },
    async getTB() {
      // console.log('ini iklannya', this.item)
      await this.$req
        .get(this.$root.$baseapi.iklan+'/iklan/v3/iklan_tb_mokas', {
          params: {
            id: this.iklan._source.id
          }
        })
        .then(response => {
          let { data } = response.data;
          this.dataIklan = data;

          let now = this.moment
            .utc(data.server_time)
            .add(this.utc, 'h')
            .toDate();
          now.setDate(now.getDate() - 1);
          // console.log('data',data)

          let s = this.moment
            .utc(data.tanggal_mulai)
            .add(this.utc, 'h')
            .toDate();
          s.setDate(s.getDate() - 1);

          let d = this.moment
            .utc(data.tanggal_selesai)
            .add(this.utc, 'h')
            .toDate();
          d.setDate(d.getDate() - 1);

          this.countdown2 = d - now;
          this.countdown = s - now;
        })
        .catch(error => {
          let responses = error;
          console.log(responses);
        });
    }
  },
  async created() {
    console.log('banner sub', this.item);
    console.log('banner iklan', this.iklan);
    if (this.iklan._source.id_mst_iklan_jenis == 2) {
      await this.getTB();
    }
  }
};
</script>

<style></style>
